const pickerElem = document.querySelector('.picker');
if (pickerElem) {
  const ticketPlaceholder = document.querySelector('.picker__item--ticket .picker__button-placeholder');
  const datepickerPlaceholder = document.querySelector('.picker__item--datepicker .picker__button-placeholder');
  const guestsPlaceholder = document.querySelector('.picker__item--guests .picker__button-placeholder');
  const pickerItems = document.querySelectorAll('.picker__item');
  const allTicketItems = document.querySelectorAll('.picker__dropdown-item');
  const pickerReset = document.querySelector('.picker__reset');
  const pickerMobileSubmit = document.querySelector('.confirm-selection--mobile');

  const toggleOverlay = (toggle) => {
    document.body.classList.toggle('overlay-visible', toggle);
    toggleBodyScrollLock(toggle);
  };

  const togglePickerDropdown = (element, toggle) => {
    element.classList.toggle('is-active', toggle);
  };

  const toggleMobileSubmitBtn = (toggle) => {
    pickerMobileSubmit.classList.toggle('is-active', toggle);
  };

  const closeOtherDropdowns = () => {
    pickerItems.forEach((item) => {
      item.classList.remove('is-active');
    });
  };

  const resetPickerForm = (ele) => {
    const parentForm = ele.target.closest('form');
    parentForm.reset();

    setTimeout(() => {
      const placeholderTexts = document.querySelectorAll('.picker__button-placeholder[data-placeholder]');
      const pickerItems = document.querySelectorAll('.picker__item');

      placeholderTexts.forEach((placeholder) => {
        const text = placeholder.getAttribute('data-placeholder');
        placeholder.innerHTML = text;
      });

      closeOtherDropdowns();

      const datePickerButtons = document.querySelectorAll('.mbsc-segmented-item');
      datePickerButtons.forEach((btn) => {
        btn.click();
        setTimeout(() => {
          const clearBtn = btn.querySelector('.mbsc-range-label-clear');
          clearBtn?.click();
        }, 100);
      });

      allTicketItems.forEach((step) => {
        step.classList.remove('show-sub', 'hide');
      });

      pickerItems.forEach((item, i) => {
        item.classList.remove('is-selected');
        item.classList.remove('is-active');

        if (i > 0) {
          item.classList.add('is-disabled');
        }
      });

      toggleBackButton();
    }, 100);

    toggleMobileSubmitBtn(false);
  };

  attachEvent('.picker__button', 'click', (ev) => {
    const parentElem = ev.target.closest('.picker__item');
    const isOpen = parentElem.classList.contains('is-active');

    if (isOpen) {
      closeOtherDropdowns();
    } else {
      closeOtherDropdowns();
      togglePickerDropdown(parentElem, true);
    }

    toggleOverlay(!isOpen);
    ev.preventDefault();
  });

  attachEvent('.picker__overlay', 'click', () => {
    closeOtherDropdowns();
    toggleOverlay(false);
    pickerElem.classList.remove('is-open');
  });

  attachEvent('.picker__dropdown-back', 'click', (btn) => {
    const parent = btn.target.closest('.picker__dropdown');
    const openItems = parent.querySelectorAll('.show-sub');
    const totalOpenItems = openItems.length - 1;
    const lastOpen = openItems[totalOpenItems];
    const lastOpenParent = lastOpen.closest('.picker__dropdown-inner');
    const childItems = lastOpenParent.children;
    lastOpen.classList.remove('show-sub');
    Array.from(childItems).forEach((el) => {
      el.classList.remove('hide');
    });
    toggleBackButton();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeOtherDropdowns();
      toggleOverlay(false);
    }
  });

  // ------
  // Open Picker - Mobile
  // ------

  const selectTicketElem = document.querySelector('.picker__item--ticket');

  const togglePicker = (toggle) => {
    pickerElem.classList.toggle('is-open', toggle);
    selectTicketElem.classList.add('is-active');
    toggleOverlay(toggle);
  };

  attachEvent('.picker__mobile-trigger', 'click', (ev) => {
    togglePicker(true);
    ev.preventDefault();
  });

  // ------
  // Close Picker - Mobile
  // ------

  attachEvent('.picker__close-btn, .language-dropdown__placeholder', 'click', (ev) => {
    togglePicker(false);
    closeOtherDropdowns();
    ev.preventDefault();
  });

  // ------
  // Submit Header Picker form
  // ------
  attachEvent('.confirm-selection, .picker-search-button,.confirm-selection--mobile', 'click', (e) => {
    e.preventDefault();

    const formData = {};
    document.querySelectorAll('.picker__form input').forEach((input) => {
      if (input.type === 'text') {
        formData[input.name] = input.value.trim();
      } else if (input.type === 'radio' && input.checked) {
        formData[input.name] = input.id.trim();
      } else if (input.type === 'checkbox' && input.checked) {
        formData[input.name] = input.value.trim();
      }
    });
    const formatDate = (date, locale) =>
      date
        .toLocaleString(locale, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
        .replace(/ /g, '');
    let checkIn;
    let checkOut;
    let locale;
    if (formData['ticket-step-2'] === 'pools' || formData['ticket-step-2'] === 'saunas') {
      // eslint-disable-next-line no-multi-assign
      checkIn = checkOut = new Date(mobiscrollEl._lastSelected);
      locale = 'sl-si';
    } else {
      checkIn = new Date(mobiscrollEl.__value[0]);
      checkOut = new Date(mobiscrollEl.__value[1]);
      locale = 'en-CA';
    }
    formData.s = formatDate(checkIn, locale);
    const ID =
      formData['ticket-step-4'] !== undefined && formData['ticket-step-4'] !== null
        ? formData['ticket-step-4']
        : formData['ticket-step-3'];
    const url =
      formData['ticket-step-2'] === 'pools' || formData['ticket-step-2'] === 'saunas'
        ? `${localData.reservationURL}types=${formData['ticket-step-2']}&s=${formData.s}&adults=${formData['number-of-adults']}&children=${formData['number-of-child']}`
        : `${checkDate(ID, checkIn, checkOut)}`;
    // adults=${formData['number-of-adults']}&children=${
    //     formData['number-of-child']}
    window.open(url, '_blank');
    // Reset form after submit
    resetPickerForm(e);
  });

  // ------
  // Reset Header Picker form
  // ------

  if (pickerReset) {
    pickerReset.addEventListener('click', (e) => {
      resetPickerForm(e);
      e.preventDefault();
    });
  }

  // ------
  // Open Picker - Steps
  // ------

  const ticketInputs = document.querySelectorAll('.picker__item--ticket input');
  const dateEleButton = document.querySelector('.date-picker .btn');

  const moveStep = (element, input) => {
    const nextStep = element.nextElementSibling;
    element.classList.toggle('is-active', false);
    element.classList.toggle('is-selected', true);
    nextStep.classList.toggle('is-active', true);
    nextStep.classList.toggle('is-disabled', false);

    const singleDatepicker = input.getAttribute('data-single-date');

    if (singleDatepicker) {
      mobiscrollEl.setOptions({
        select: 'single',
        pages: 1,
      });
    }
    nextStep.classList.toggle('has-single-datepicker', singleDatepicker);
  };

  const backButton = document.querySelector('.picker__dropdown-back');

  const toggleBackButton = () => {
    const openItems = document.querySelectorAll('.show-sub');
    backButton.classList.toggle('show', openItems.length > 0);
  };

  const handleTicketItem = (superParent, ele) => {
    const parentEle = ele.closest('.picker__dropdown-item');
    const subitem = parentEle.querySelector('.picker__dropdown-inner');

    if (subitem) {
      const innerItems = subitem.querySelectorAll('.picker__dropdown-item');

      allTicketItems.forEach((item) => item.classList.toggle('hide', !item.classList.contains('show-sub')));
      innerItems.forEach((item) => item.classList.toggle('hide', false));

      parentEle.classList.toggle('hide', false);
      parentEle.classList.toggle('show-sub', true);
    } else {
      moveStep(superParent, ele);
    }

    toggleBackButton();
  };

  const nextStepActive = (ele) => {
    const superParent = ele.closest('.picker__item');

    if (superParent.classList.contains('picker__item--ticket')) {
      handleTicketItem(superParent, ele);
    } else {
      moveStep(superParent, ele);
    }
  };

  ticketInputs.forEach((el) => {
    el.addEventListener('change', (ev) => {
      nextStepActive(ev.target);
    });
    el.addEventListener('click', (ev) => {
      nextStepActive(ev.target);
    });
  });

  if (dateEleButton) {
    dateEleButton.addEventListener('click', (ev) => {
      nextStepActive(ev);
    });
  }

  attachEvent('.confirm-selection, .picker-search-button', 'click', (ev) => {
    const parentEle = ev.target.closest('.picker__item');
    parentEle.classList.remove('is-active');
    parentEle.classList.add('is-selected');
    closeOtherDropdowns();
    toggleOverlay(false);
    pickerElem.classList.remove('is-open');
    ev.preventDefault();
  });

  // ------
  // Selected Item Replace With Placeholder
  // ------

  // Total Guests
  const counterSum = (ele) => {
    const parentEle = ele.target.closest('.picker__item--guests');
    const inputEle = parentEle.querySelectorAll('.counter__input');
    guestsPlaceholder.innerHTML = Array.from(inputEle).reduce((sum, input) => sum + parseFloat(input.value), 0);
  };

  // Ticket
  ticketInputs.forEach((el) => {
    el.addEventListener('change', (ev) => {
      const parentEle = ev.target.closest('.picker__dropdown-item');
      ticketPlaceholder.innerHTML = parentEle.querySelector('.picker__dropdown-item-title').innerHTML;
    });
  });

  // Date
  mobiscrollEl.setOptions({
    onChange: (event, inst) => {
      const parent = event.inst.base.closest('.picker__item');

      if (!parent.classList.contains('has-single-datepicker') && event.value.length > 0) {
        const formattedStartDate = event.value[0].toLocaleString('sl-si', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
        const formattedEndDate = event.value[1]
          ? event.value[1].toLocaleString('sl-si', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
            })
          : '';

        datepickerPlaceholder.innerHTML = formattedEndDate
          ? `${formattedStartDate} - ${formattedEndDate}`
          : `${formattedStartDate}`;

        if (event.value[1]) {
          nextStepActive(inst.base);
          toggleMobileSubmitBtn(true);
        }
      }
    },
    onCellClick: (event) => {
      const parent = event.target.closest('.picker__item');
      if (parent.classList.contains('has-single-datepicker')) {
        const formattedDate = event.date.toLocaleString('sl-si', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
        datepickerPlaceholder.innerHTML = formattedDate;
        nextStepActive(event.target);
        toggleMobileSubmitBtn(true);
      }
    },
  });

  attachEvent('.picker__dropdown--datepicker .btn', 'click', () => {
    datepickerPlaceholder.innerHTML = 'Flex';
  });

  // Counter
  attachEvent('.picker__item--guests .counter__button--add', 'click', counterSum);
  attachEvent('.picker__item--guests .counter__button--remove', 'click', counterSum);

  // ------
  // Open last enabled item
  // ------
  attachEvent('.picker__item.is-disabled', 'click', () => {
    const items = document.querySelectorAll('.picker__item:not(.is-disabled)');
    const lastItem = items.length - 1;
    items[lastItem].classList.add('is-active');
  });

  // **************************************************

  attachEvent('.open-picker', 'click', () => {
    closeOtherDropdowns();
    toggleOverlay(true);
    toggleMenuClass(false);
    toggleBodyScrollLock(true);
    togglePicker(true);
  });
  const getUrl = (data) => {
    const { hotelId } = data;
    const destination = `${data.destination}`;
    let url = `${localData.reservationPhobsURL}&company_id=${encodeURI(data.companyId)}&date=${encodeURI(
      data.arrival,
    )}&nights=${encodeURI(data.nights)}`;
    if (destination !== 'undefined') {
      url += `&destination=${encodeURI(destination)}`;
    }
    if (hotelId !== 'undefined') {
      url += `&hotel=${encodeURI(hotelId)}`;
    }
    if (typeof window.getCkyConsent === 'function') {
      const consent = getCkyConsent();
      if (consent?.categories?.analytics === true) {
        return `${url}&cookie-consent=1`;
      }
    }
    return url;
  };

  const checkDate = (hotelIds, arrival, departure) => {
    if (arrival == null) {
      arrival = new Date();
    }
    if (departure == null) {
      departure = new Date(arrival);
      departure.setDate(departure.getDate() + 1);
    }
    let nights = '';
    if (arrival !== null) {
      nights = Math.round((departure.getTime() - arrival.getTime()) / (1000 * 60 * 60 * 24));
    }
    let arrivalStr = '';
    if (arrival !== null) {
      arrivalStr = `${arrival.getFullYear()}-${arrival.getMonth() + 1}-${arrival.getDate()}`;
    }
    let selectedType = '';
    let companyId = '';
    let destinationId = '';
    let hotelId = '';
    const ids = hotelIds.split('|');
    if (ids.length >= 3) {
      // eslint-disable-next-line prefer-destructuring
      selectedType = ids[0];
      // eslint-disable-next-line prefer-destructuring
      companyId = ids[1];
      // eslint-disable-next-line prefer-destructuring
      hotelId = ids[2];
      if (selectedType === 'group') {
        destinationId = hotelId;
      }
    }
    let url = '';
    if (selectedType === 'hotel') {
      url = getUrl({
        companyId,
        hotelId,
        arrival: arrivalStr,
        nights,
      });
    } else {
      if (selectedType === 'group') {
        url = getUrl({
          companyId,
          arrival: arrivalStr,
          nights,
          destination: destinationId,
        });
      } else {
        url = getUrl({
          companyId,
          arrival: arrivalStr,
          nights,
        });
      }
    }
    return url;
  };
}
